<script setup>
const props = defineProps({
    imgUrl: String,
})
const dialog = defineModel()

</script>

<template>
    <v-card class="pa-5">
        <template v-slot:default>
            <v-img :src="imgUrl" />
        </template>
        <template v-slot:actions>
            <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialog = false"
            ></v-btn>
        </template>
    </v-card>
</template>

<style scoped>

</style>